import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';


export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/hire-pdmlink-customization-expert', label: 'PDMLink' },
    { path: '/hire-projectlink-customization-expert', label: 'ProjectLink' },
    { path: '/hire-supplier-management-expert', label: 'SUMA' },
    { path: '/hire-creo-view-visualization-expert', label: 'Creo' },
    { path: '/hire-infrastructure-customization-expert', label: 'Infrastructure' },
    { path: '/hire-windchill-customization-expert', label: 'Customization' },
    { path: '/hire-windchill-upgrade-expert', label: 'Upgrades' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src="/logo.png" alt="Logo" style={{ height: '110px' }} />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive(item.path)
                  ? 'text-[#00890b] bg-green-50'
                  : 'text-gray-700 hover:text-[#00890b] hover:bg-green-50'
                  }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Contact Button */}
          <div className="hidden lg:block">
            <Button
              onClick={() => {
                const contactForm = document.getElementById('contact-form');
                if (contactForm) {
                  contactForm.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-[#00890b] hover:bg-[#006a08] text-white"
            >
              Get in Touch
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden pb-4 space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${isActive(item.path)
                  ? 'text-[#00890b] bg-green-50'
                  : 'text-gray-700 hover:text-[#00890b] hover:bg-green-50'
                  }`}
              >
                {item.label}
              </Link>
            ))}
            <Button
              onClick={() => {
                setIsMenuOpen(false);
                const contactForm = document.getElementById('contact-form');
                if (contactForm) {
                  contactForm.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="w-full bg-[#00890b] hover:bg-[#006a08] text-white"
            >
              Get in Touch
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};